import {
    BathroomMedium,
    BedroomMedium,
    LivingRoomMedium
} from '@zoopla-eng/zds/icons';
import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    amenityItemStyle,
    amenityLabelScreenReaderOnlyStyle,
    amenityListStyle
} from './amenities.styles.css';

type AmenitiesProps = {
    bedrooms?: number;
    bathrooms?: number;
    livingRooms?: number;
};

const Amenities: React.FC<AmenitiesProps> = ({
    bedrooms,
    bathrooms,
    livingRooms
}) => {
    return bedrooms || bathrooms || livingRooms ? (
        // eslint-disable-next-line jsx-a11y/no-redundant-roles
        <ul className={`${amenityListStyle} ${fontGroups.fork}`} role="list">
            {bedrooms ? (
                <li className={amenityItemStyle}>
                    <span className={amenityLabelScreenReaderOnlyStyle}>
                        Bedrooms
                    </span>
                    <BedroomMedium />
                    <span>{bedrooms}</span>
                </li>
            ) : null}
            {bathrooms ? (
                <li className={amenityItemStyle}>
                    <span className={amenityLabelScreenReaderOnlyStyle}>
                        Bathrooms
                    </span>
                    <BathroomMedium />
                    <span>{bathrooms}</span>
                </li>
            ) : null}
            {livingRooms ? (
                <li className={amenityItemStyle}>
                    <span className={amenityLabelScreenReaderOnlyStyle}>
                        Living rooms
                    </span>
                    <LivingRoomMedium />
                    <span>{livingRooms}</span>
                </li>
            ) : null}
        </ul>
    ) : null;
};

export { Amenities };
